import React from 'react';
import {TailSpin} from "react-loader-spinner";
import * as S from './Styles';

const Loader = ({ fullheight = "false" }: { fullheight?: string }) => (
    <S.Loader fullheight={fullheight}>
        <TailSpin
            color="#0985c7"
            height={50}
            width={50}
        />

        <h2>
            Loading...
        </h2>
    </S.Loader>
)

export { Loader }
